<svelte:head>

    <title>Collecting • keyosh</title>

</svelte:head>

<script>
    import Collecting from "../../components/onboarding/collecting.svelte"
</script>


<section>

    <Collecting />

</section>


<style>

    section {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        height: inherit;
    }

    @media screen and (max-width: 1024px) {

        section {
            min-height: 100vh;
        }

    }

</style>
